



































import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import NoResults from "@/components/ui/NoResults.vue";
import { Component } from "vue-property-decorator";
import BaseInternalValorization
    from "@/components/pages/valorizations/internal/observatory/BaseInternalValorization.vue";

am4core.useTheme(am4themes_animated);

@Component({
  components: {
    NoResults
  }
})
export default class Base extends BaseInternalValorization {
  protected element: HTMLElement | null = null;
  protected chart: am4charts.Chart | null = null;
  protected series = [];
  protected data = [];
  protected title = "";
  protected subTitle = "";
  protected description = "";

  drawChart() {
    this.chart = am4core.create(this.element!!, am4charts.PieChart);
    // this.chart.hiddenState.properties.opacity = 0;

    this.chart.data = this.data;

    this.chart.exporting.menu = new am4core.ExportMenu();
    this.chart.exporting.filePrefix = this.subTitle + " : " + this.title;
  }

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  mounted() {
    this.element = this.$refs.chart as HTMLElement;
  }
}
